import React from "react";
import {observable, action, computed} from 'mobx';
import AssetInstitutionService from '../../services/AssetInstitutionService';
import {objDeepCopy, isEmpty, BUSINESS_INFO, getUrlParms} from '../../utils/tool';
import { DEFAULT_ERROR_MSG } from "../../utils/config";

class AssetInstitution {
  condition = {};
  @observable auctionList = []; // 拍品信息
  @observable headerAuctionList = []; // 拍品信息
  @observable targetPageNo = "1"; // 拍品分页
  @observable collapsePageNo = "1"; // 拍品分页
  @observable targetListHasMore = true; // 拍品列表加载
  @observable errorMessage = true; // 拍品列表加载
  @observable collapseListHasMore = true; // 拍品列表加载
  @observable realTimeData = {}; // 拍品实时数据
  @observable curTabIndex = 0; // Tabs当前索引值
  @observable curPageTitle = ''; // 当前页面标题
  @observable vendorId = ''; // 商家Id
  @observable apiType = ''; // 业务线参数调取接口用
  @observable publishSource = ''; // 业务线参数
  @observable labelSet = 1039; // 区分海关和政府 海关:1030 政府:1039，默认海关
  @observable orgType = ''; // 区分海关政府id类型 customes:orgType = 12 ，vendorId:orgType = 1 
  @observable zhiBoFloorClientHeight = 0; // 直播楼层模块高度
  @observable customsStates = 0; 
  @observable keyWord = '' // 商品搜索关键词
  @observable loading = false // 接口搜索中
  @observable idType = 0; //
  // 缓存数据初始化
  // 缓存数据来自 滚动事件 滚动高度 筛选条件 数据列表
  @action.bound
  initStore(allStatus) {
    for (let key in allStatus) {
      this[key] = allStatus[key];
    }
    this.getRealTimeData(this.auctionList);
  }

  @action.bound
  saveCurrData(name, data) {
    this[name] = objDeepCopy(data);
  }
  @action.bound
  changeKeyWord(val){
    this.keyWord = val
  }
  @action.bound
  changeLoading(val){
    this.loading = val
  }
  @action.bound
  addCondition(condition, isUserFilterEvent) {
    if (isUserFilterEvent) {
      // 如果是用户操作的筛选信息变更，需要清空置顶ID
      this.condition.topIdList = ''
      this.condition.collapseSrcPaimaiId = ''
    }
    for (let key in condition) {
      if (condition[key] == 'none') {
        delete this.condition[key];
        delete condition[key];
      }
    }

    this.resetAuctionList();
    this.condition = Object.assign(this.condition, condition);
    this.getAuctionList();

    this.resetHeaderAuctionList();
  }

  @action.bound
  resetHeaderAuctionList() {
    this.headerAuctionList = []; // 清空拍品信息
  }

  @action.bound
  resetAuctionList() {
    this.auctionList = []; // 清空拍品信息
    this.targetPageNo = "1"; // 重置拍品分页
    this.targetListHasMore = true; // 拍品列表加载
    this.errorMessage = ''; // 错误提示
    this.realTimeData = {};
  }

  @action.bound
  getCollapseHeaderAuctionList(e, index) {
    let params = {excludeCollapseSelf:false, page: 1, pageSize: "30", apiType: this.apiType, sortField:8};
    if(this.publishSource==BUSINESS_INFO.HAIGUANANDZF.code){ //海关政府
      params.orgId= this.vendorId
      params.publishSource= this.publishSource
      params.orgType= this.orgType
      params.multiDisplayStatus= 1
      params.statusSearchFlag = 1
    }else{
    }
    if (isEmpty(this.condition)) {
      params = Object.assign(params);
    } else {
      params = Object.assign(params, this.condition);
    }

    params = Object.assign(params, e);
    // 不在需要隐藏拍品
    params.collapseSrcPaimaiId = getUrlParms("excludeCollapsePaimaiId")
    
    // 请求标的列表数据
    return AssetInstitutionService.getCollapseAuctionList(params).then(
      res => {
        let auctionNewList = [];
        let headerAuctionList = this.headerAuctionList
        if (res && res.datas && res.datas.length) {
          auctionNewList = res.datas;
          headerAuctionList.splice(index, 0, ...auctionNewList)
          // 请求实时数据
          this.getRealTimeData(res.datas);
        } else {
          // this.collapseListHasMore = false;
        }
        return Promise.resolve(res);
      }
    )
  }

  @action.bound
  getCollapseAuctionList(e, index) {
    let params = {excludeCollapseSelf: true,page: 1, pageSize: "30", apiType: this.apiType, sortField:8};
    if(this.publishSource==BUSINESS_INFO.HAIGUANANDZF.code){ //海关政府
      params.orgId= this.vendorId
      params.publishSource= this.publishSource
      params.orgType= -1
      params.idType= this.idType
      params.multiDisplayStatus= 1
      params.statusSearchFlag = 1
    }else{
    }
    if (isEmpty(this.condition)) {
      params = Object.assign(params);
    } else {
      params = Object.assign(params, this.condition);
    }

    params = Object.assign(params, e);

    // 请求标的列表数据
    return AssetInstitutionService.getCollapseAuctionList(params).then(
      res => {
        let auctionNewList = [];
        if (res && res.datas && res.datas.length) {
          auctionNewList = res.datas;
          // 请求实时数据
          this.getRealTimeData(auctionNewList);
        } else {
          // this.collapseListHasMore = false;
        }
        return Promise.resolve(res);
      }
    )
  }

  @action.bound
  getSellectionParams() {
    let params = {collapseSize: 3, page: this.targetPageNo, pageSize: "10", apiType: this.apiType, sortField:8};
    if(this.publishSource==BUSINESS_INFO.HAIGUANANDZF.code){ //海关政府
      params.orgId= this.vendorId
      params.publishSource= this.publishSource
      // 241114: 为兼容线上数据orgType更改为-1, 本次上线后，该参数可以删除
      params.orgType = -1
      params.multiDisplayStatus= 1
      params.statusSearchFlag = 1
      params.idType = this.idType
    }else{
      params.vendorId= this.vendorId
    }
    if (isEmpty(this.condition)) {
      params = Object.assign(params);
    } else {
      params = Object.assign(params, this.condition);
    }

    if(params.paimaiIdList) {
      delete params.page
    }

    // 需要不展示的拍卖id列表
    // params.excludePaimaiIdList = getUrlParms("excludeCollapsePaimaiId")

    params.keyWord = this.keyWord.trim();
    return params
  }

  @action.bound
  getAuctionList() {
    const params = this.getSellectionParams()
    this.changeLoading(true)
    // 请求标的列表数据
    return AssetInstitutionService.getTargetAuctionList(params).then(
      res => {
        let auctionList = [];
        if (res && res.datas && res.datas.length) {
          auctionList = res.datas;
          this.auctionList.push(...auctionList);
          if (params.paimaiIdList) {

          }else {
            if (auctionList.length < 10) {
              this.targetListHasMore = false;
            }
            let targetPageNoLast = parseInt(this.targetPageNo);
            targetPageNoLast += 1;
            this.targetPageNo = targetPageNoLast.toString();
          }
          // 请求实时数据
          this.getRealTimeData(auctionList);
        } else {
          this.targetListHasMore = false;
        }
        this.errorMessage = ''
        return Promise.resolve();
      }
    ).catch(err => {
      this.errorMessage = DEFAULT_ERROR_MSG;
    }).finally(() => {
      this.changeLoading(false);
    })
  }
  @action.bound
  getRealTimeData = (auctionList) => {
    // 请求实时数据
    let paimaiIds = [];
    auctionList.forEach(value => {
      paimaiIds.push(value.id)
    });

    this.getRealTimeDataByPaimaiIds(paimaiIds);
  };

  @action.bound
  getRealTimeDataByPaimaiIds = (paimaiIds) => {
    // 请求实时数据
    AssetInstitutionService.realTimeRefresh(paimaiIds).then(
      res => {
        if (res && res.data && Object.keys(res.data).length) {
          Object.keys(res.data).forEach(paimaiId => {
            this.realTimeData[paimaiId] = res.data[paimaiId];
          })

        }
      }).catch(err => {
        console.log('realTimeRefresh error:', err);
      })
  };

  @action.bound
  changeTab(curTabIndex) {
    this.curTabIndex = curTabIndex;
  }

  setAssetTargetData = () => {
    sessionStorage.setItem('assetTargetIndex', JSON.stringify({
      targetPageNo: this.targetPageNo,
      targetListHasMore: this.targetListHasMore,
      auctionList: this.auctionList,
      condition: this.condition,
      realTimeData: this.realTimeData,
      SortItem: this.SortItem,
      ClassifyItem: this.ClassifyItem,
      LocationItem: this.LocationItem,
      MoreItem: this.MoreItem,
      currFilterItems: this.currFilterItems,
    }))
  }

  // 将当前选中的Tabs索引写入缓存
  setTabIndex = () => {
    sessionStorage.setItem('curTabIndex', this.curTabIndex);
  }
}

let assetInstitution = new AssetInstitution();

export default assetInstitution;
